import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import Resource from "./resource";

@JsonObject()
export class PermissionsResource extends Resource {
    @JsonProperty("permissions")
    @JsonElementType(String)
    permissions: Array<string>;
}
